import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Grid,
  Typography,
  Paper,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';

import {
  convert24HourTimezoneTime,
  convert24to12hourtime,
  convertTimezoneTime,
  // truncate,
  createProfileRoute,
  getLanguageNameByCode,
  prettifyOscarDate,
} from '../../../shared/Helpers';
import {
  dayNumbers,
  numberDays,
  daysOfWeek,
} from '../../../shared/Mappings';
import { GOOGLE_MAPS_NAV_LINK } from '../../../shared/Constants';
import niaMarker from '../../../static/img/icons/location_icon.svg';

const styles = theme => ({
  listItemPaper: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    padding: theme.spacing(),
    [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
      marginTop: theme.spacing(),
      padding: theme.spacing(),
    },
  },
  listItem: {
    padding: 0,
  },
  iconButton: {
    height: '200px',
    width: '200px',
  },
  trainerImg: {
    height: '180px',
    width: '180px',
  },
  pad: {
    padding: theme.spacing(),
  },
  eventName: {
    textTransform: 'uppercase',
    letterSpacing: 3,
  },
  trainerName: {
    textTransform: 'uppercase',
    color: theme.palette.primary.dark,
  },
  trainerLink: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
    '&:visited': {
      color: theme.palette.primary.dark,
    },
  },
  beltIcon: {
    height: 48,
    width: 48,
    verticalAlign: 'text-bottom',
    marginLeft: theme.spacing(2),
  },
  rightColumnTop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  padNotTop: {
    paddingRight: theme.spacing(),
    paddingLeft: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
  rightColumn: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  detailsButton: {
    marginRight: 4,
    marginLeft: 4,
  },
  usd: {
    fontSize: '14px',
  },
  price: {
    padding: theme.spacing(2),
  },
  timezone: {
    fontSize: '12px',
  },
  classTimes: {
    textTransform: 'uppercase',
    fontSize: '16px',
    paddingBottom: theme.spacing(),
    color: theme.palette.primary.dark,
  },
  classDatesText: {
    paddingTop: theme.spacing(),
  },
  smallerText: {
    fontSize: '13px',
  },
  classTimesHeader: {
    textTransform: 'uppercase',
    paddingBottom: theme.spacing(),
  },
  niaMarker: {
    verticalAlign: 'text-bottom',
    height: 22,
    width: 22,
  },
  directionsLink: {
    textDecoration: 'none',
    textTransform: 'none',
    fontSize: 12,
    color: theme.palette.blue,
    '&:visited': {
      color: theme.palette.blue,
    },
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    '&:visited': {
      color: 'inherit',
    },
  },
  locationAddress: {
    fontSize: 12,
  },
  avatarContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
  },
});

const grabClassTimes = (classObj) => {
  const arrayWithNull = daysOfWeek.map((dayOfWeek) => {
    const output = (classObj[dayOfWeek.toLowerCase()]
      ? {
        day: dayOfWeek,
        start: classObj[`${dayOfWeek.toLowerCase()}_start`],
        end: classObj[`${dayOfWeek.toLowerCase()}_end`],
      }
      : null);
    return output;
  });
  return arrayWithNull.filter(day => !!day);
};

const renderDailySchedule = (classTimesArray, userTimezone, classTimezone, currentDay) => {
  const schedule = [];
  classTimesArray.forEach((classDay) => {
    // console.log(day);
    // console.log(currentDay);
    // console.log('classtimezone: ', classTimezone);
    if (typeof classDay.day === 'undefined') {
      return null;
    }
    if (typeof classDay.start === 'undefined') {
      return null;
    }
    if (typeof classDay.end === 'undefined') {
      return null;
    }
    let startTime = 'timezone error';
    let endTime = 'timezone error';
    let dayChange = 0;
    try {
      if (classDay.start.toLowerCase().includes('am') || classDay.start.toLowerCase().includes('pm')) {
        [startTime, dayChange] = convertTimezoneTime(classDay.start, userTimezone, classTimezone);
        [endTime, dayChange] = convertTimezoneTime(classDay.start, userTimezone, classTimezone);
      } else if (classTimezone === '') {
        // class timezone not present
        startTime = convert24to12hourtime(classDay.start);
        endTime = convert24to12hourtime(classDay.end);
        dayChange = 0;
      } else {
        [startTime, dayChange] = convert24HourTimezoneTime(classDay.start, userTimezone, classTimezone);
        [endTime, dayChange] = convert24HourTimezoneTime(classDay.end, userTimezone, classTimezone);
      }
    } catch (error) {
      console.log(error);
      return null;
    }
    // console.log('dayChange', dayChange);
    let theDay = classDay.day;
    if (dayChange === 1) {
      if (classDay.day === 'Sunday') {
        theDay = 'Monday';
      } else {
        let dayNum = numberDays[classDay.day];
        dayNum += 1;
        theDay = dayNumbers[dayNum];
      }
    }
    if (dayChange === -1) {
      if (classDay.day === 'Monday') {
        theDay = 'Sunday';
      } else {
        let dayNum = numberDays[classDay.day];
        dayNum -= 1;
        theDay = dayNumbers[dayNum];
      }
    }
    if (theDay !== currentDay && currentDay !== 'Any Day') return null;
    // if (i === 0) {
    //   return (
    //     <span color="textPrimary">{theDay.substring(0, 3) + ' ' + time}</span>
    //   );
    // }
    // return (
    //   <span color="textPrimary">{', ' + theDay.substring(0, 3) + ' ' + time}</span>
    // );
    schedule.push(theDay + 's ' + startTime + '-' + endTime);
  });
  return schedule.join(', ');
};

const renderButton = (event, classes, handlePopupOpen) => {
  if (event.event_type.depends_on_text !== '') {
    return (
      <Button onClick={e => handlePopupOpen(e, event.event_type.depends_on_text, event.event_type.depends_on_checkbox, event.link)} variant="contained" color="secondary" className={classes.detailsButton}>Learn More</Button>
    );
  }
  return (
    <Button target="_blank" variant="contained" color="secondary" className={classes.detailsButton} href={event.link}>Learn More</Button>
  );
};

const renderLocationTitle = (item) => {
  if (item.distance === undefined || item.distance === null) {
    return item.location.title;
  }
  return item.location.title + ' (' + item.distance.substring(0, 3) + 'mi)';
};

const TrainingListItem = ({
  classes,
  event,
  userTimezone,
  currentDay,
  handlePopupOpen,
}) => (
  <Paper className={classes.listItemPaper} elevation={1}>
    <ListItem className={classes.listItem}>
      <Grid container>
        <Grid item sm={12} md={3} className={classes.avatarContainer}>
          <IconButton href={createProfileRoute(event.user.username)} className={classes.iconButton}>
            <Avatar alt="trainer profile" src={event.user_img} className={classes.trainerImg} />
          </IconButton>
        </Grid>
        <Grid item sm={12} md={9}>
          <Grid container className={classes.pad}>
            <Grid item xs={11}>
              <Typography variant="h5" className={classes.eventName}>
                {'Nia ' + event.event_type.level}
                {event.event_type.extra !== '' ? <span className={classes.extra}>{' - ' + event.event_type.extra}</span> : null}
              </Typography>
              <Typography variant="subtitle1" className={classes.trainerName}>
                with
                <a target="_blank" rel="noopener noreferrer" className={classes.trainerLink} href={createProfileRoute(event.user.username)}>
                  {' ' + event.user.first_name + ' ' + event.user.last_name + ' '}
                </a>
                {event.language && (
                  <span className={classes.smallerText}>{'(' + getLanguageNameByCode(event.language) + ')'}</span>
                )}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.rightColumnTop}>
              <img src={event.event_type.img} alt="belt icon" className={classes.beltIcon} />
            </Grid>
          </Grid>
          <Grid container className={classes.padNotTop}>
            <Grid item xs={7}>
              <Typography variant="h6" className={classes.classDatesText}>{prettifyOscarDate(event.start_date) + ' - ' + prettifyOscarDate(event.end_date)}</Typography>
              {event.online ? (
                <React.Fragment>
                  <Typography className={classes.classTimes}>
                    {renderDailySchedule(grabClassTimes(event), userTimezone, event.timezone, currentDay)}
                  </Typography>
                  <Typography className={classes.timezone}>
                    SHOWING TIMES IN:
                    <strong>{' ' + userTimezone}</strong>
                  </Typography>
                </React.Fragment>
              )
                : (
                  <React.Fragment>
                    {event.location && (
                      <Typography color="textSecondary" className={classes.classTimesHeader}>
                        <Link to={'/location/' + event.location.id} className={classes.link}>
                          <img alt="nia marker" className={classes.niaMarker} src={niaMarker} />
                          {renderLocationTitle(event)}
                        </Link>
                        <span className={classes.locationAddress}>{' - ' + event.location.address + ' '}</span>
                        <span color="secondary"><a target="_blank" rel="noopener noreferrer" className={classes.directionsLink} href={GOOGLE_MAPS_NAV_LINK + encodeURIComponent(event.location.address)}>Get Directions</a></span>
                      </Typography>
                    )}
                  </React.Fragment>
                )
              }
              {event.timezone && (
                <Typography className={classes.timezone}>
                  {'EVENT TIMEZONE: ' + event.timezone}
                </Typography>
              )}
            </Grid>
            <Grid item xs={5} className={classes.rightColumn}>
              {event.event_type.price !== ''
                ? (
                  <Typography className={classes.price} variant="h5">
                    {'$' + event.event_type.price + ' '}
                    <span className={classes.usd}>USD</span>
                  </Typography>
                )
                : <Typography />
              }
              {renderButton(event, classes, handlePopupOpen)}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </ListItem>
  </Paper>
);

TrainingListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  currentDay: PropTypes.string.isRequired,
  userTimezone: PropTypes.string.isRequired,
  handlePopupOpen: PropTypes.func.isRequired,
};

export default withStyles(styles)(TrainingListItem);
